export default function PHP_Casting() {
  return (
    <div>
      <h1>PHP_Casting</h1>
    </div>
  );
}
